import type { ThresholdSimulatorState } from './state';

export function setThresholdSimParamsByPublicId(
  state: ThresholdSimulatorState,
  action: { payload: any },
) {
  const publicId = action.payload.activeThreshold;
  if (!state[publicId]) {
    state[publicId] = {};
  }
  state[publicId].params = {
    validStartDate: action?.payload?.validStartDate,
    validEndDate: action?.payload?.validEndDate,
    evalsNeeded: action?.payload?.evalsNeeded,
    error: action?.payload?.error,
    isLoading: action?.payload?.isLoading,
  };
}
